const ALLOWED_HOSTS = ['talentcrux.ai', 'www.talentcrux.ai'];

export function sanitizeReturnUrl(url, fallback = '/') {
  if (!url) return fallback;

  try {
    if (url.startsWith('/') && !url.startsWith('//')) return url;

    const parsed = new URL(url, window.location.origin);

    if (parsed.origin === window.location.origin) return url;

    if (ALLOWED_HOSTS.includes(parsed.hostname)) return url;

    return fallback;
  } catch {
    return fallback;
  }
}
